
import React, { createContext, useState, useEffect, useCallback } from 'react';
import api from '../api/axios';

export const CheckinContext = createContext();

export const CheckinProvider = ({ children, enabled = true }) => {
  const STORAGE_KEY = 'lastCheckinDate';

  const [lastCheckinDate, setLastCheckinDate] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || null;
  });
  const [streak, setStreak] = useState({
    current: null,
    longest: null,
    reward: null,
    expired: false,
  });
  const [showModal, setShowModal] = useState(false);

  const hydrateStreakStatus = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await api.get('/miniapp/checkin-streak/');
      const { current_streak, longest_streak, expired } = res.data;
      setStreak((prev) => ({
        ...prev,
        current: current_streak,
        longest: longest_streak,
        reward: null,
        expired: Boolean(expired),
      }));
    } catch (err) {
      console.error('Streak status load failed', err);
    }
  }, [enabled]);

  const triggerCheckin = useCallback(async () => {
    if (!enabled) return;
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const res = await api.post('/miniapp/checkin-streak/', { tz });
      const {
        current_streak,
        longest_streak,
        reward_type,
        reward_value,
        reward_description,
        expired,
      } = res.data;
      const today = new Date().toISOString().slice(0, 10);
      setLastCheckinDate(today);
      localStorage.setItem(STORAGE_KEY, today);
      setStreak({
        current: current_streak,
        longest: longest_streak,
        reward: reward_type ? { type: reward_type, value: reward_value, description: reward_description } : null,
        expired: Boolean(expired),
      });
      setShowModal(Boolean(reward_type));
    } catch (err) {
      console.error('Check-in failed', err);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    const today = new Date().toISOString().slice(0, 10);
    if (lastCheckinDate !== today) {
      void triggerCheckin();
      return;
    }
    void hydrateStreakStatus();
  }, [enabled, hydrateStreakStatus, lastCheckinDate, triggerCheckin]);

  return (
    <CheckinContext.Provider
      value={{
        lastCheckinDate,
        streak,
        showModal,
        setShowModal,
        triggerCheckin,
        refreshStreakStatus: hydrateStreakStatus,
      }}
    >
      {children}
    </CheckinContext.Provider>
  );
};
